import React from 'react'
import { getText } from '../shared/customization';

export default function Messages() {
  return (
    <div>
      {getText('Messages.Title')}
    </div>
  )
}